exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centerHrt {\n  position: fixed;\n  top: 50%;\n  right: 0px;\n  width: 51px;\n  height: 0px;\n  text-align: right;\n  z-index: 9999;\n  margin-top: -15px; }\n\n.centerHrt a {\n  transform: rotate(-90deg);\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  display: block;\n  background: #ec008c;\n  text-align: center;\n  height: 45px;\n  width: 80px;\n  padding-top: 3px;\n  color: #fff;\n  font-family: Arial, sans-serif;\n  font-size: 17px;\n  font-weight: normal;\n  text-decoration: none;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px; }\n\n.centerHrt a:hover {\n  background: #ec008c; }\n\n.example-container {\n  width: 500px;\n  border: 1px solid rgba(0, 0, 0, 0.5); }\n\n.example-sidenav-content {\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.example-sidenav {\n  padding: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/sidebar/sidebar.component.scss
// module id = ../../../../../src/app/sidebar/sidebar.component.scss
// module chunks = 1